export default async function refetchSources(guid: string, videoApiURL: string): Promise<Source[]> {
  const query = encodeURIComponent(
    `query SourcesUncached { programs(guid: "${guid}") { items { sources { type file drm } } } }`,
  );

  const response = await fetch(`${videoApiURL}/graphql?query=${query}&timestamp=${Date.now()}`, {
    method: 'GET',
    headers: window.isProduction ? {} : { 'x-client-details': 'qa' },
  });

  const { data } = await response.json();
  return data?.programs?.items?.[0]?.sources || [];
}
